import Vue from 'vue';
import Main from './main.vue';

let ModalConstructor = Vue.extend(Main);
let component;

ModalConstructor.prototype.hide = function() {
  this.show = false;
};
ModalConstructor.prototype.update = function(options) {
  for(let key in options) {
    this[key] = options[key];
  }
  this.show = true;
};

const show = function(options) {
  options = options || {};
  if(component) {
    component.update(options);
  } else {
    component = new ModalConstructor({
      data: options
    }).$mount();
    document.body.appendChild(component.$el);
  }
};
const hide = function() {
  component.hide();
};

export default {
  show,
  hide
};

